export function getFileType(mimeType = '', url = '') {
    const mime = (mimeType || '').toLowerCase()
    const ext = (url || '')
        .split('?')[0]
        .split('.')
        .pop()
        .toLowerCase()

    if (mime.includes('pdf') || ext === 'pdf') {
        return 'pdf'
    }

    if (mime.includes('word') || ['doc', 'docx'].includes(ext)) {
        return 'word'
    }

    if (mime.includes('powerpoint') || mime.includes('presentation') || ['ppt', 'pptx'].includes(ext)) {
        return 'ppt'
    }

    return 'pdf'
}

export function getFileTypeLabel(type) {
    if (type === 'word') {
        return 'DOC'
    }

    if (type === 'ppt') {
        return 'PPT'
    }

    return 'PDF'
}

// Локализованная подпись кнопки: «Ներբեռնել PDF» / «Download PPT» и т.д.
// Тип берётся из расширения/mime файла, а не жёстко «PDF».
export function getFileDownloadLabel(type, lang) {
    const prefix = lang === 'hy' ? 'Ներբեռնել' : 'Download'

    return `${prefix} ${getFileTypeLabel(type)}`
}
